import {Loader} from "./loader";
import * as Url from "url";

export const filters = {
    manufacturer: async (id) => {
        Loader.load()
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('filters[manufacturer]')
        urlSearchParams.delete('page')
        let filters = urlSearchParams
        if (id) {
            filters = `filters[manufacturer]=${id}&${urlSearchParams}`
        }
        window.location.search = decodeURI(filters.toString())
    },
    price: async (value = '') => {
        Loader.load()

        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('filters[price]')
        urlSearchParams.delete('page')
        let filters = urlSearchParams
        if (value) {
            filters = `filters[price]=${value}&${urlSearchParams}`
        }

        window.location.search = filters.toString()
    },
    attribute: async (group, value = '') => {
        Loader.load()

        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete(`filters[${group}]`)
        urlSearchParams.delete('page')

        let filters = urlSearchParams
        if (group && value) {
            group = decodeURI(group)
            filters = `filters[${group}]=${value}&${urlSearchParams}`
        }
        window.location.search = decodeURI(filters.toString())
    },
    range: () => {
        return {
            minprice: 1,
            maxprice: 191,
            min: 1,
            max: 191,
            minthumb: 0,
            maxthumb: 0,
            mintrigger() {
                this.minprice = Math.min(this.minprice, this.maxprice - 1);
                this.minthumb = ((this.minprice - this.min) / (this.max - this.min)) * 100;
            },
            maxtrigger() {
                this.maxprice = Math.max(this.maxprice, this.minprice + 10);
                this.maxthumb = 100 - (((this.maxprice - this.min) / (this.max - this.min)) * 100);
            },
        }
    },
    reset: (element) => {
        const el = document.getElementById(element)
        if (el.type === 'radio') {
            el.checked = false
            el.dispatchEvent(new Event('click'))
        } else {
            el.value = ''
            el.dispatchEvent(new Event('change'))
        }
    }
}